export const API_RETRY_SCHEDULED = 'API_RETRY_SCHEDULED';
export const API_RETRY_SUCCEEDED = 'API_RETRY_SUCCEEDED';

export const apiRetryScheduled = ms => ({
  type: API_RETRY_SCHEDULED,
  ms,
});

export const apiRetrySucceeded = () => ({
  type: API_RETRY_SUCCEEDED,
});



// WEBPACK FOOTER //
// ./src/actions/api-connectivity.js